import { useSelector } from 'react-redux'
import { settingsSelectors } from 'store/settings'
import { AuthMode, AuthModeEnum } from 'types/setting'

export const useAuthMode = (): AuthMode => useSelector(settingsSelectors.authMode)

export const useIsAuthModeExternal = (): boolean => useAuthMode() === AuthModeEnum.External
export const useIsAuthModeNoLogin = (): boolean => useAuthMode() === AuthModeEnum.NoLogin
